import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

export function FieldError({ error }) {
  if (!error) return null;

  return (
    <span className="text-xs font-normal flex items-center gap-1">
      <ExclamationCircleIcon className="size-5 text-coral-400" />
      {error}
    </span>
  );
}
